import {ApiPostRaw} from '../../../shared/services/api-service';

const getAverageByForm = (data) =>
  ApiPostRaw('/api/v1/analytics/rating-average', data)

export {
  getAverageByForm
}
